import getStore from '../../store/store';

export default function getDefaultTodoCustomData() {
    return {
        panelSessionId: getPanelSessionId(),
    };
}

function getPanelSessionId(): string {
    return getStore().panelId;
}
